// This file was generated with `npm run icons:generate`. Don’t edit directly.
import Icon from 'tailwind/components/Icon/Icon';
import { IconOuterProps } from 'tailwind/components/Icon/Icon.types';

const UtilityStrokeCameraSmallIcon = (props: IconOuterProps) => (
  <Icon {...props} viewBox="0 0 16 16">
    <mask id="icon__mask0_8840_8383" style={{ maskType: 'luminance' }} maskUnits="userSpaceOnUse" x="1" y="1" width="14" height="14">
      <path d="M1 0.999999H15V15H1V0.999999Z" fill="var(--icon-color-accent)" />
    </mask>
    <g>
      <path
        d="M11.8993 4.30859C11.5205 4.30859 11.1742 4.09459 11.0049 3.75581L10.7373 3.22075C10.5679 2.88197 10.2217 2.66797 9.8429 2.66797H6.1571C5.77832 2.66797 5.43206 2.88197 5.26267 3.22075L4.99514 3.75581C4.82575 4.09459 4.47949 4.30859 4.10072 4.30859H2.41016C1.85787 4.30859 1.41016 4.75631 1.41016 5.30859V12.332C1.41016 12.8843 1.85787 13.332 2.41016 13.332H13.5898C14.1421 13.332 14.5898 12.8843 14.5898 12.332V5.30859C14.5898 4.75631 14.1421 4.30859 13.5898 4.30859H11.8993Z"
        stroke="var(--icon-color-main)"
        strokeWidth="0.8"
        strokeMiterlimit="10"
        strokeLinejoin="round"
      />
      <path
        d="M8 10.0508C7.09536 10.0508 6.35938 9.3148 6.35938 8.41016C6.35938 7.50552 7.09536 6.76953 8 6.76953C8.90464 6.76953 9.64063 7.50552 9.64063 8.41016C9.64063 9.3148 8.90464 10.0508 8 10.0508Z"
        stroke="var(--icon-color-main)"
        strokeWidth="0.8"
        strokeMiterlimit="10"
      />
      <path d="M3 5.94922H3.82031" stroke="var(--icon-color-main)" strokeWidth="0.8" strokeMiterlimit="10" strokeLinecap="round" />
    </g>
  </Icon>
);

export default UtilityStrokeCameraSmallIcon;
